const EOfferStatus = {
  PENDING: { en: "pending", de: "wartend" },
  ACCEPTED: { en: "accepted", de: "akzeptiert" },
  DECLINED: { en: "declined", de: "abgelehnt" },
  WITHDRAWED: { en: "withdrawed", de: "zurückgezogen" },
  COUNTER_OFFER: { en: "counter offer", de: "Gegenangebot" },
};

export default EOfferStatus;
